// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../doc-site/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../doc-site/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bolt-split-button-main {
  border-bottom-right-radius: 0px;
  border-top-right-radius: 0px;
}

.bolt-split-button .bolt-split-button-option {
  padding: 9px;
  border-bottom-left-radius: 0px;
  border-top-left-radius: 0px;
}

body.bolt-focus-visible .bolt-split-button-main:focus,
body.bolt-focus-visible .bolt-split-button-option:focus {
  border-radius: 2px;
}

.bolt-split-button-divider {
  background-color: rgba(0, 0, 0, 0.20);
  background-color: var(--palette-black-alpha-20,rgba(0, 0, 0, 0.20));
  width: 1px;
}
.bolt-split-button-divider.primary {
  background-color: rgba( 0, 91, 161 ,  1 );
  background-color: rgba( var(--palette-primary-darkened-10,0, 91, 161) ,  1 );
}
.bolt-split-button-divider.disabled {
  background-color: rgba(0, 0, 0, 0.10);
  background-color: var(--palette-black-alpha-10,rgba(0, 0, 0, 0.10));
}

/*# sourceMappingURL=SplitButton.css.map */
`, "",{"version":3,"sources":["webpack://./../azure-devops-ui/src/Components/SplitButton/SplitButton.scss","webpack://./../azure-devops-ui/bin/Components/SplitButton/SplitButton.css","webpack://./../azure-devops-ui/src/Core/_platformCommon.scss"],"names":[],"mappings":"AACA;EACI,+BAAA;EACA,4BAAA;ACAJ;;ADGA;EACI,YAAA;EACA,8BAAA;EACA,2BAAA;ACAJ;;ADKQ;;EAEI,kBAAA;ACFZ;;ADOA;EACI,qCE+Fe;EF9Ff,mEAAA;ECJF,UAAU;ADMR;ACJJ;EACE,yCAAyC;EDOvC,4EAAA;ACLJ;AACA;EACE,qCAAqC;EACrC,mEAAmE;AACrE;;AAEA,0CAA0C","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
